import React, { useState } from 'react';
import { Home, Pizza, ShoppingCart, Phone, Star, Instagram, Facebook, Youtube, Mail } from 'lucide-react';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import CartPage from './pages/CartPage';
import ContactPage from './pages/ContactPage';

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [activeSection, setActiveSection] = useState('home');

  

  const addToCart = (pizza) => {
    setCartItems([...cartItems, pizza]);
  };

  const renderContent = () => {
    const url = window.location.search;
    const params = new URLSearchParams(url);
    const section = params.has("contact") ? 'contact' : activeSection;

    switch(section) {
      case 'menu':
        return <MenuPage addToCart={addToCart} />;
      case 'cart':
        return <CartPage cartItems={cartItems} />;
      case 'contact':
        return <ContactPage />;  
      default:
        return <HomePage setActiveSection={setActiveSection} />;
    }
  };

  return (
    <div className="min-h-screen bg-yellow-50">
      <header className="bg-hoc-main text-white py-4 px-6 flex justify-between items-center">
        <h1 className="text-2xl font-bold">
          
          <a href="/">
            <img 
              src="/img/logoWhite.png" 
              alt="House Of Crust" 
              className=" h-16 object-cover rounded-lg"
            />
          </a>
        </h1>
        <nav className="flex space-x-4">
          <button 
            onClick={() => setActiveSection('home')} 
            className="hover:bg-amber-700 p-2 rounded"
          >
            <Home size={24} />
          </button>
          <button 
            onClick={() => setActiveSection('menu')} 
            className="hover:bg-amber-700 p-2 rounded"
          >
            <Pizza size={24} />
          </button>
          {/* <button 
            onClick={() => setActiveSection('cart')} 
            className="hover:bg-amber-700 p-2 rounded relative"
          >
            <ShoppingCart size={24} />
            {cartItems.length > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                {cartItems.length}
              </span>
            )}
          </button> */}
        </nav>
      </header>

      <main className="container mx-auto">
        {renderContent()}
      </main>

      <footer className="bg-hoc-main text-white py-6 mt-8">
        <div className="container mx-auto flex justify-between items-center">
          <div>
            <h3 className="font-bold text-xl">House Of Crust</h3>
            <p className="text-sm">Delivering passion in every slice</p>
          </div>
          <div className="flex space-x-4">
           <a href="mailto:info@houseofcrust.co.uk" className="hover:text-amber-500">
              <Mail size={24} />              
            </a>
            <a href="tel:07967148166" className="hover:text-amber-500">
              <Phone size={24} />              
            </a>
            {/* <a href="#" className="hover:text-amber-500">
              <Youtube  size={24} />
            </a> */}
            <a href="https://www.instagram.com/houseofcrust_uk/" className="hover:text-amber-500" target="_blank" rel="noreferrer">
              <Instagram   size={24} />
            </a>
            {/* <a href="#" className="hover:text-amber-500">
              <Tiktok  size={24} />
            </a> */}
            {/* <a href="#" className="hover:text-amber-500">
              <Facebook  size={24} />
            </a> */}
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
